var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authGuard.isAuthenticated())?_c('app-navigation-drawer'):_vm._e(),_c('v-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }